import React from 'react';
import { notification } from 'antd';

const stickyError = (message, duration = 0, contactSupport = false, title = 'Error') => {
	if (contactSupport) {
		message = <span>{message}<br /><br />Please contact SAS tech support at <a href="mailto:techsupport@semesteratsea.org">techsupport@semesteratsea.org</a></span>;
	}
	notification.error({
		message: title,
		description: message,
		duration: 0
	});
}

module.exports = stickyError;


const stickyErrorAdmissions = (message, duration = 0, contactSupport = false, title = 'Error') => {
	if (contactSupport) {
		message = <span>{message}<br /><br />Please contact the Program Administration team at <a href="mailto:programadministration@isevoyages.org">programadministration@isevoyages.org</a></span>;
	}
	notification.error({
		message: title,
		description: message,
		duration: 0
	});
}

module.exports = stickyErrorAdmissions;



// WEBPACK FOOTER //
// ./portal-components/stickyError/index.js